import IconPtBr from '../assets/images/languages/pt_br.png';
import IconEnUs from '../assets/images/languages/en_us.png';
import IconEsEs from '../assets/images/languages/es_es.png';
import DefaultConstants from './Constants';

const Languages = [
    {
        icon: IconPtBr,
        initials: "PT",
        text: 'portuguese',
        value: "pt_br"
    }, {
        icon: IconEnUs,
        initials: "EN",
        text: 'english',
        value: "en_us"
    }, {
        icon: IconEsEs,
        initials: "ES",
        text: 'spanish',
        value: "es_es"
    }
];

export default Languages.sort((a, b) => {
    if (a.value === DefaultConstants.language) {
        return -1;
    }

    if (b.value === DefaultConstants.language) {
        return 1;
    }

    return 0;
});